import React from 'react';
import { useTranslation } from 'react-i18next';

import './ViewPeriodSwitch.styles.css';

const PERIODS = [
    {
        id: 'day',
        nameKey: 'day_short'
    },
    {
        id: 'week',
        nameKey: 'week_short'
    },
    {
        id: 'month',
        nameKey: 'month_short'
    },
    {
        id: 'year',
        nameKey: 'year_short'
    }
];


const SwitchButton = ({ id, name, isActive, onClick }) => {
    const handleClick = () => onClick && onClick(id);

    return <button className={'btn btn-secondary' + (isActive ? ' active' : '')} onClick={handleClick}>{ name }</button>
};


const ViewPeriodSwitch = ({ value, disabled, onChange }) => {
    const { t } = useTranslation('date');

    return (
        <div className={'view-period-switch' + (disabled ? ' disabled' : '')}>
            {
                PERIODS.map(({ id, nameKey }) => <SwitchButton
                    key={id}
                    id={id}
                    name={t(nameKey)}
                    isActive={value === id}
                    onClick={!disabled && onChange}
                />)
            }
        </div>
    );
};

export default ViewPeriodSwitch;
